<script>
import Status from '../Status'
import Audio from '../Audio'
import Dropdown from '../../common/Dropdown'
import { invoiceMixins, ListsMixins, teamTaskMixins, urlQueriesMixins, userTeamMixins } from '../../../utils/mixins'
import ComboBox from '../form/formModules/ComboBox.vue'
import moocCourseProvider from '../../../services/mooc/course'
import PrintCertificatesModal from '../../mooc/issuanceOfCertificate/PrintCertificatesModal.vue'
import skillUpCourseProvider from '../../../services/skillUp/course'
import skillUpIssuanceCertificate from '../../../services/skillUp/issuanceOfACertificate'
import CourseUsers from '../../skillup/courses/CourseUsers.vue'
import skillUpPackageProvider from '../../../services/skillUp/package'

export default {
  mixins: [userTeamMixins, teamTaskMixins, invoiceMixins, ListsMixins, urlQueriesMixins],
  components: {
    Dropdown,
    Status,
    Audio,
    ComboBox,
    PrintCertificatesModal,
    CourseUsers,
  },
  props: {
    striped: {
      type: Boolean,
      default: false,
    },
    checkedList: Array,
    url: {
      type: String,
    },
    selectRoute: {
      type: String,
      default: '',
    },
    imgStyle: {
      type: String,
    },
    imgClass: {
      type: String,
    },
    heightStyle: {
      type: String,
      default: '',
    },
    clickToChangeRoute: {
      default: true,
      type: Boolean,
    },
    isCrm: {
      default: false,
      type: Boolean,
    },
    fields: {
      default: [],
    },
    rows: {
      default: [],
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
    invoice: {
      type: Boolean,
      default: false,
    },
    noNeedToChangeRoute: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      selectMode: 'single',
      certificateMode: {},
      selected: null,
      selectedRole: '',
      filter: null,
      filterOn: [],
      actionSelect: false,
      items: null,
      selectedId: 'کاربر',
      showUserNameSearch: false,
      showUserPhoneSearch: false,
      userNameSearch: '',
      userPhoneSearch: '',
      userRols: [
        { value: 'کاربر', key: 1 },
        { value: 'ادمین', key: 2 },
        { value: 'استاد', key: 3 },
        { value: 'منتور', key: 4 },
      ],
      selectedCheckBox: [],
      eye: 0,
    }
  },
  mounted() {
    if (!localStorage.getItem('query')) {
      localStorage.setItem('query', `?pageNumber=1&perPage=10`)
    }
    this.selectedCheckBox = this.checkedList
  },

  methods: {
    async submitScore(id, score) {
      const req = await skillUpCourseProvider.setUserScore({
        id,
        score,
      })
    },
    async submitOrder(id, order, items) {
      if (['courses-package-activities', 'courses-package-course-activities'].includes(this.$route.name)) {
        await skillUpPackageProvider.updateActivityOrder({
          packageId: +items.find((item) => item.fieldName === 'PackageId').value,
          courseId: +items.find((item) => item.fieldName === 'CourseId').value,
          courseSessionId: +items.find((item) => item.fieldName === 'CourseSessionId').value,
          courseSessionFileId: +items.find((item) => item.fieldName === 'CourseSessionFileId').value,
          order,
        })
        return
      }
      await skillUpCourseProvider.setOrder({
        packageId: +this.$route.params.packageId,
        courseId: id,
        order,
      })
    },
    fillRole(id) {
      return this.userRols.find((item) => item.key === +id)?.value
    },
    updateRole(e, rowId) {
      const data = {
        id: +rowId,
        productId: +this.$route.params.courseId || +this.$route.params.packageId,
        productType: this.$route.params.courseId ? 0 : 1,
        status: e.key,
      }
      if (data.status) {
        this.$emit('updateRole', data)
      }
    },
    async checkHasLicense(peopleId) {
      const req = await skillUpIssuanceCertificate.hasLicense({
        id: this.$route.params.courseId,
        peopleId: peopleId,
      })

      if (req.status === 200) {
        const payload = {
          peopleId: peopleId,
          hasLicense: req.data.data.output,
        }
        window.localStorage.setItem('checkHasLicense', JSON.stringify(payload))
      }
    },
    blankPage(route, id) {
      const blankRoute = this.$router.resolve(`${route}/detail/${id}`)
      return window.open(blankRoute.href, '_blank')
    },
    findItems(array, fieldName) {
      return array.find((item) => item.fieldName === fieldName)
    },
    goDetail(row, index) {
      if (this.eye > 0) return

      const route = this.$route
      const modal = this.$bvModal
      if (route.name === 'userTransactionDetail') {
        const array = row.items
        const payload = {
          date: this.findItems(array, 'Date').value,
          price: this.findItems(array, 'NormalizePrice').value,
          fullName: this.findItems(array, 'FullName').value,
          SHABANumber: this.findItems(array, 'ShabaNumber').value,
          isIncreaseColor: this.findItems(array, 'IsIncrease').color,
          isIncreaseValue: this.findItems(array, 'IsIncrease').value,
          payDescription: this.findItems(array, 'PayDescription').value,
          referenceNumber: this.findItems(array, 'ReferenceNumber').value,
          manualPaymentUrl: this.findItems(array, 'ManualPaymentUrl').value,
          manualPaymentUrlName: this.findItems(array, 'ManualPaymentUrlName').value,
          manualPaymentUrlType: this.findItems(array, 'ManualPaymentUrlType').value,
          isIncreaseStatusColor: this.findItems(array, 'IsIncreaseStatus').color,
          isIncreaseStatusValue: this.findItems(array, 'IsIncreaseStatus').value,
          manualPaymentDescription: this.findItems(array, 'ManualPaymentDescription').value,
          id: this.findItems(array, 'Id').value,
          transactionId: +this.$route.params.transactionId,
          manualPaymentStatus: this.findItems(array, 'IsIncreaseStatus').value === 'در انتظار واریز ' ? false : true,
        }
        // this.$store.commit('wallet/WALLET_INFORMATION', payload)

        const route = this.$router.resolve(`/list/allbalancewithuserinfo/transactionDetail/${payload.id}`)
        window.open(route.href, '_blank')
        localStorage.setItem('transactionDetail', JSON.stringify(payload))
      }
      if (route.path.includes('allbalancewithuserinfo')) {
        const userId = this.rowsItems[index].items.find((item) => item.fieldName === 'UserId').value
        const fullName = row.items.find((item) => item.fieldName === 'FullName').value
        const walletType = row.items.find((item) => item.fieldName === 'Coin').value === 'تومان' ? 'TOMAN' : 'SKILLCOIN'

        localStorage.setItem('walletUserInformation', JSON.stringify({ userId: userId, userName: fullName, walletType }))
      }
      if (route.path === '/list/teacherskilluporders') return
      if (route.path.includes('/list/skilluptotalcomments')) localStorage.setItem('templateId', row.items.find((item) => item.fieldName === 'PostTemplate').value)
      if (['universityreport', 'skillupadvice'].includes(route.params.slug)) return

      if (['universitylicense', 'skilluplicense'].includes(route.params.slug)) {
        row.items.reduce((obj, item) => {
          obj[item.fieldName] = item.value
          localStorage.setItem('certificateInformation', JSON.stringify(obj))
          return obj
        }, {})
      }
      if (['/list/skillupcourses', '/list/skilluppackages', '/list/skilluppractice', '/list/allbalancewithuserinfo'].includes(route.path)) {
        this.blankPage(route.path, row.id)
      }
      if (route.name === 'mooc-issuance-certificate') {
        modal.show('certificateModal')
        this.certificateMode = row
      } else if (route.name === 'skillUp-issuance-certificate') {
        modal.show('skillUpCertificateModal')
        this.certificateMode = row
        this.checkHasLicense(row.id)
      } else if (route.params.slug === 'homecategory') {
        modal.show('homeCategoryModal')
      } else if (['universitycategorypackage', 'universitycategorycourse'].includes(route.params.slug)) {
        modal.show('categoryModal')
      } else if (route.params.slug?.includes('skillupcategory')) {
        modal.show('skillUpCategoryModal')
      } else if (route.params.slug?.includes('skillupcertificates')) {
        modal.show('partnerModal')
      } else if (!this.noNeedToChangeRoute) {
        if (this.invoice) {
          this.setSelectedRow({ row, index })
        } else {
          if (this.isCrm == false) {
            this.onRowSelected(row)
          } else {
            this.$router.push({ path: `/teamtask/${this.routeParam}/details/${row.key}` })
          }
        }
      }
      this.$emit('selectedRow', row)
    },
    addTab(payload) {
      return this.addTeamTaskTab({
        teamTaskTab: payload,
      })
    },
    setActiveTabName(payload) {
      return this.setActiveTab({
        activeTab: payload,
      })
    },
    clearUrlQueries() {
      // this.setSearchQuery('')
      // this.setCurrentPage(1)
      // this.setFields([])
      // this.setPageSize(10)
      this.setCleanQueries()
    },
    onRowSelected(items) {
      if (this.actionSelect) return
      if (this.clickToChangeRoute === true) {
        this.clearUrlQueries()

        if (this.$route.params.slug === 'cryptowallet') {
          this.setSelectedRow({ items })
          this.$router.push({
            path: `/list/specificUserWalletTransactions/fromListsWallet/${items.items[7].value === 'تومان' ? 'toman' : items.items[7].value}/${items.items[6].value}`,
          })
          this.selected = items
          return
        } else {
          if (
            this.$route.path === `/list/specificUserWalletTransactions/fromListsWallet/${this.$route.params.slug}/${this.$route.params.id}` ||
            this.$route.path === `/list/specificUserWalletTransactions/fromUserManagement/${this.$route.params.slug}/${this.$route.params.id}`
          ) {
            this.$router.push({ path: `/list/${this.selectRoute}/${items.key}` })
          } else {
            if (
              [
                '/list/packages',
                '/list/courses',
                '/list/users',
                '/list/teachers',
                '/list/articles',
                '/list/ruleandregulation',
                '/list/adminstudents',
                '/list/mentors',
                '/list/discount',
                '/list/skillupdiscount',
                '/list/facultyuniversitycourses',
                '/list/universitycourses',
                '/list/facultyshortuniversitypackages',
                '/list/facultylonguniversitypackages',
                '/list/longuniversitypackages',
                '/list/shortuniversitypackages',
                '/list/posts',
                '/list/totalcomments',
                '/list/skillupallcareers',
                '/list/skilluppractice',
              ].includes(this.$route.path)
            ) {
              const route = this.$router.resolve({ path: `${this.selectRoute}/${items.key}` })
              localStorage.setItem('query', `?pageNumber=${this.$route.query.pageNumber || 1}&perPage=${this.$route.query.perPage || 10}`)
              window.open(route.href)
            } else if (['/list/skilluporders', '/list/agentskilluporders'].includes(this.$route.path)) {
              const route = this.$router.resolve({
                path: `${this.selectRoute}/${items.key}/?isInstallment=${this.findItems(items.items, 'IsInstallment').value}&isCancel=${
                  this.findItems(items.items, 'IsCancel').value
                }`,
              })
              localStorage.setItem('query', `?pageNumber=${this.$route.query.pageNumber || 1}&perPage=${this.$route.query.perPage || 10}`)
              window.open(route.href)
            } else if (['universitycategorypackage', 'universitycategorycourse', 'skillupcategory'].includes(this.$route.params.slug)) {
              this.$emit('selectedRow', items)
            } else if (this.$route.name === 'course-courseadminstudents' || this.$route.name === 'package-packageadminstudents') {
              this.$router.replace(`${this.$route.path}detail/${items.key}`)
            } else if (this.$route.name === 'courses-package') {
              this.$router.push(`${this.$route.path}/activities/${items.key}`)
            } else {
              this.$router.resolve({
                path: `${this.selectRoute}/${items.key}`,
              })
              this.$router.push({ path: `${this.selectRoute}/${items.key}` })
            }
          }
          this.selected = items
        }
      } else {
        this.addTab(items.key)
        this.setActiveTabName(items.key)
        const path = this.$route.path
        this.$router.push({ path: `${path}?navLink=${items.key}` })
      }
    },
    GridView() {
      this.$router.push({ path: '/teamtask-board' })
    },
    deleteItem(item) {
      this.$emit('deleteRow', item)
      this.$bvModal.hide(`deleteModal-${item}`)
    },
    hideSearch() {
      if (this.showUserNameSearch || this.showUserPhoneSearch) {
        this.showUserNameSearch = false
        this.showUserPhoneSearch = false
      }
    },
    fillCheckBox(e, data) {
      if (e) {
        this.selectedCheckBox.push(data)
      } else {
        const current = this.selectedCheckBox.indexOf(this.selectedCheckBox.find((item) => item.productId == data.productId && item.productType == data.productType))
        this.selectedCheckBox.splice(current, 1)
      }
      this.$emit('selected', this.selectedCheckBox)
    },
    handleEyeHover(id) {
      this.eye = id
    },
  },
  computed: {
    routeParam() {
      return this.$route.params.slug
    },
    routeName() {
      return this.$route.name
    },
    rowsItems() {
      let rows = []
      if (
        this.$route.name === 'courses-package' ||
        this.$route.name === 'course-prerequisites' ||
        this.$route.name === 'package-prerequisites' ||
        this.$route.name === 'course-users' ||
        ['universitycategorycourse', 'skillupcategory', 'universitycategorypackage', 'homecategory', 'slider'].includes(this.$route.params.slug) ||
        this.$route.path === '/list/homeslider' ||
        this.$route.path === '/list/skillupcertificates'
      ) {
        rows = this.rows.map((item) => {
          const hasDelete = item.items.find((obj) => obj.type === 'Delete')
          const hasClass = item.items.find((obj) => obj.fieldName === 'Status')?.value

          if (!hasDelete) {
            item.items.push({
              color: '',
              fieldName: 'Delete',
              class: hasClass === 'ثبت نام آنلاین' ? 'disable' : 'redIcon',
              id: null,
              size: 16.7,
              type: 'Delete',
              typeEnum: 0,
              value: 'fa-regular fa-circle-xmark',
            })
          }
          return item
        })
      } else if (
        this.$route.path === '/list/discount/add' ||
        this.$route.path === '/list/discount/detail/' + this.$route.params.id ||
        this.$route.path === '/list/skillupdiscount/add' ||
        this.$route.path === '/list/skillupdiscount/detail/' + this.$route.params.id
      ) {
        rows = this.rows.map((item) => {
          const hasSelect = item.items.find((obj) => obj.type === 'Select')
          const value = { productType: 1, productId: 0 }
          const selectedValue = this.checkedList.find((i) => i.productId == item.id)
          item.items.forEach((item) => {
            if (item.fieldName === 'ProductId') {
              value.productId = +item.value
            }
            if (item.fieldName === 'ProductType' && item.value.includes('د')) {
              value.productType = 0
            }
          })
          if (!hasSelect) {
            item.items.push({
              color: '',
              fieldName: 'Select',
              id: null,
              size: 16.7,
              type: 'Select',
              typeEnum: 0,
              value,
              selectedValue: selectedValue && selectedValue.productId ? true : false,
            })
          }
          return item
        })
      } else rows = this.rows

      return rows
    },
    newFields() {
      const fields = this.fields
      if (
        this.$route.name === 'courses-package' ||
        this.$route.name === 'course-prerequisites' ||
        this.$route.name === 'package-prerequisites' ||
        this.$route.name === 'course-users' ||
        this.$route.path === '/list/homeslider' ||
        this.$route.path === '/list/skillupcertificates'
      ) {
        const hasDelete = fields.find((obj) => obj.key === 'Delete')
        if (!hasDelete) {
          fields.push({
            index: fields.length + 1,
            order: fields.length + 1,
            key: 'Delete',
            label: '',
            type: 'Action',
            isCollection: false,
            size: 15,
          })
        }
      }
      if (
        this.$route.path === '/list/discount/add' ||
        this.$route.path === '/list/discount/detail/' + this.$route.params.id ||
        this.$route.path === '/list/skillupdiscount/add' ||
        this.$route.path === '/list/skillupdiscount/detail/' + this.$route.params.id
      ) {
        const hasSelect = fields.find((obj) => obj.key === 'Select')
        if (!hasSelect) {
          fields.push({
            index: fields.length + 1,
            order: fields.length + 1,
            key: 'Select',
            label: 'انتخاب',
            type: 'Action',
            isCollection: false,
            size: 15,
          })
        }
      }
      return fields
    },
  },
  watch: {
    userNameSearch(c) {
      setTimeout(() => {
        this.$emit('updateUserSearch', c)
      }, 2000)
    },
    userPhoneSearch(c) {
      setTimeout(() => {
        this.$emit('updateUserSearch', c)
      }, 2000)
    },
  },
}
</script>

<template>
  <div class="mb-0" :class="fixedHeight === true ? 'topDivTable' : ''">
    <table class="table main-table">
      <thead class="mainThead" :class="fixedHeight === true ? 'theadFixed' : ''">
        <tr>
          <template v-for="col in newFields">
            <th v-if="col.type != 'Hidden'" :key="col.key" class="ellipsis" :style="`width:${col.size}%;${col.label === '#' ? 'font-size: 20px;' : ''}`">
              <span class="cell" data-bs-toggle="tooltip" :title="col.label">{{ col.label }}</span>

              <div v-if="$route.name === 'course-users' && col.label === 'تلفن'" class="arrow" @click="showUserPhoneSearch = true">
                <img :key="col.key" style="margin-right: -10px" src="../../../assets/images/dadbanan/table-down.svg" />
              </div>

              <div v-if="$route.name === 'course-users' && col.label === 'تلفن' && showUserPhoneSearch" class="search-box" v-click-outside="hideSearch">
                <input type="text" v-model="userPhoneSearch" placeholder="جستجو..." />
              </div>

              <div v-if="$route.name === 'course-users' && col.label === 'نام و نام خانوادگی'" class="arrow" @click="showUserNameSearch = true">
                <img :key="col.key" style="margin-right: 70px" src="../../../assets/images/dadbanan/table-down.svg" />
              </div>

              <div v-if="$route.name === 'course-users' && col.label === 'نام و نام خانوادگی' && showUserNameSearch" class="search-box" v-click-outside="hideSearch">
                <input type="text" v-model="userNameSearch" placeholder="جستجو..." />
              </div>
            </th>
          </template>
          <th v-if="['universitycategorypackage', 'universitycategorycourse', 'skillupcategory', 'homecategory', 'slider'].includes(this.$route.params.slug)"></th>
        </tr>
      </thead>
      <tbody v-if="rows">
        <tr v-for="(row, index) in rowsItems" :key="row.id" @click="goDetail(row, index)" style="vertical-align: middle">
          <template v-for="data in row.items">
            <td v-if="data.type != 'Hidden'" :key="data.columnId" :style="`width:${data.size}%`" class="ellipsis">
              <span class="cell" style="direction: ltr" v-if="data.type == 'DateTimeOffset' && data.value" data-bs-toggle="tooltip" :title="FormatedDate(data.value)">{{
                FormatedDate(data.value)
              }}</span>
              <input
                v-model="data.value"
                class="cell score"
                v-else-if="data.type == 'Text' && data.fieldName == 'InOrder' && $route.fullPath.includes(`/list/skilluppackages/${$route.params.packageId}/skilluppackagecourses`)"
                type="text"
                placeholder="ترتیب فعال بودن"
                @keypress.enter="submitOrder(+row.id, +data.value)"
                @change="submitOrder(+row.id, +data.value)"
                @focus="actionSelect = true"
                @blur="actionSelect = false"
              />
              <input
                v-model="data.value"
                class="cell score"
                v-else-if="data.type == 'Text' && data.fieldName == 'Order' && ['courses-package-activities', 'courses-package-course-activities'].includes($route.name)"
                type="text"
                @keypress.enter="submitOrder(+row.id, +data.value, row.items)"
                @change="submitOrder(+row.id, +data.value, row.items)"
              />
              <span class="cell" v-else-if="data.type == 'Date' && data.value" data-bs-toggle="tooltip" :title="convertDate(data.value)">{{ convertDate(data.value) }}</span>
              <span v-else-if="data.type == 'Price' && data.value" data-bs-toggle="tooltip" :title="Commafy(data.value)" class="dLTR cell">
                {{ Commafy(data.value) }}
              </span>
              <span class="cell" v-else-if="data.type == 'Status' && data.value"><Status :status="data" color="#ff0000" /></span>
              <span class="cell" v-else-if="data.type == 'Voice' && data.value"><Audio :file="data.value" /></span>
              <span class="cell" v-else-if="data.type == 'dropDown' && data.value"><Dropdown simpleDropdown :items="userRols" /></span>
              <p v-else-if="data.type == 'DropDown' && data.value" class="drop-down">
                <ComboBox :searchedData="userRols" :selectedValue="fillRole(data.value)" placeholder="نقش" @selectedItem="updateRole($event, row.id)" result="key" />
              </p>
              <img v-else-if="data.type == 'Modal'" src="@/assets/images/dadbanan/history.svg" />
              <span class="cell" v-else-if="data.type == 'TimeSpan' && data.value">{{ timeSpanConverter(data.value) }}</span>
              <div class="cell" v-else-if="data.type == 'Image'" style="top: 10px">
                <img
                  v-if="data.value"
                  :src="data.value"
                  :alt="data.type"
                  :class="
                    routeParam === 'user' || routeParam === 'users' || routeParam === 'cryptocurrency' || routeName === 'course-users'
                      ? 'userImg'
                      : routeName == 'transactions-fromUserManagement' || routeName == 'transactions-fromListsWallet' || routeParam == 'cryptotransaction'
                      ? 'transactionMode'
                      : 'productImg'
                  "
                />
                <template v-else>
                  <img
                    v-if="
                      routeParam === 'users' || routeParam === 'user' || routeName === 'course-users' || routeParam === 'manageusers' || $route.name === 'mooc-issuance-certificate'
                    "
                    src="../../../assets/images/users/default.png"
                    alt="avatar"
                    class="userImg"
                  />
                  <img v-else src="../../../assets/images/brandDefaultPicture.svg" alt="avatar" class="productImg" />
                </template>
              </div>
              <span class="cell" v-else-if="data.fieldName === 'Score'">{{ data.value }}</span>

              <span class="cell" v-else-if="data.type == 'Color'">
                <span class="colorValue cell" v-if="data.value">{{ data.value }}</span>
                <div class="colorDiv" :style="`border: 1px solid ${data.color == '#ffffff' ? '#000' : data.color};background-color:${data.color};`"></div>
              </span>
              <span class="cell" v-else-if="data.type == 'Icon' && data.value"><i :class="`${data.value} fileStyle`" :style="`color:${data.color}`"></i></span>
              <span class="cell" v-else-if="data.type == 'Delete' && data.value" @click.stop="data.class !== 'disable' ? $bvModal.show(`deleteModal-${row.id}`) : ''"
                ><i :class="[`${data.value} fileStyle`, { disable: data.class === 'disable' }, { redIcon: data.class === 'redIcon' }]" :style="`color:${data.color}`"></i
              ></span>
              <b-form-checkbox v-else-if="data.type == 'Select'" class="checkbox" v-model="data.selectedValue" @change="fillCheckBox($event, data.value)"></b-form-checkbox>
              <span class="cell" v-else-if="data.type == 'Text' && data.value && data.fieldName !== 'Score'" data-bs-toggle="tooltip" :title="data.value">
                {{ data.value }}
                <i v-if="data.fieldName === 'NumberOfPeoples'" class="fa fa-eye eye" @mouseover="handleEyeHover(row.id)" @click="$bvModal.show(`users-modal-${row.id}`)">
                  <CourseUsers v-if="row.id === eye" :id="eye ? row.id : 0" @close="handleEyeHover(0)" />
                </i>
              </span>

              <input
                v-model="data.value"
                class="cell score"
                v-else-if="
                  data.type == 'Text' &&
                  data.fieldName == 'Score' &&
                  ($route.path.includes('university') || $route.fullPath === `/list/skillupcourses/${$route.params.courseId}/users`)
                "
                type="text"
                placeholder="نمره"
                @keypress.enter="submitScore(+row.id, +data.value)"
                @change="submitScore(+row.id, +data.value)"
              />

              <i v-else-if="data.type === 'Text' && data.fieldName === 'PrintLicense' && $route.name === 'mooc-issuance-certificate'" class="fa-regular fa-file-certificate"></i>
              <hr class="customHR" v-else-if="data.type != 'Hidden'" />
            </td>
          </template>
          <b-modal :id="`deleteModal-${row.id}`" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
            <div class="error-wrapper">
              <div class="mb-4 text-center">
                <img src="@/assets/images/checked1.svg" />
              </div>
              <div class="error-title text-center">آیا از حذف این مورد اطمینان دارید؟</div>
              <div class="mt-3 float-right w-100">
                <div class="d-flex align-items-center justify-content-center">
                  <b-button class="col-6" variant="secondary" block @click="$bvModal.hide(`deleteModal-${row.id}`)">خیر</b-button>
                  <b-button class="ms-2 col-6" variant="primary" block @click="deleteItem(row.id)">بله</b-button>
                </div>
              </div>
            </div>
          </b-modal>
        </tr>
      </tbody>
    </table>
    <div class="w-100 emptyTable" v-if="rows && rows.length == 0">
      <slot name="emptyTable"></slot>
    </div>
    <PrintCertificatesModal v-if="certificateMode" :certificateMode="certificateMode" />
  </div>
</template>
<style lang="scss" scoped>
::v-deep .emptyTable .preloader-component {
  height: 400px !important;
}
.customHR {
  margin: 0 !important;
  bottom: 10px;
  position: relative;
  height: 2px;
  background-color: #000 !important;
  opacity: 0.3;
  max-width: 50px;
}
.dLTR {
  direction: ltr !important;
}
table {
  width: 100%;
}
.ellipsis {
  position: relative;
}
.ellipsis:before {
  content: '&nbsp;';
  visibility: hidden;
}
.ellipsis .cell {
  position: absolute;
  left: 0px;
  right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ellipsis {
  p {
    position: absolute;
    top: 10px;
  }
}
.ellipsis div .productImg,
.ellipsis div .userImg {
  top: 5px;
}
.filter {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.filterTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #555555;
}
.globalFlex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.filterOptions {
  margin-right: 10px;
  width: 86px;
  height: 37px;
  padding: 8px 15px;
  background: #3ea3fc;
  border-radius: 30px;
}
.filterText {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: right;
  color: #ffffff;
}
.GridView {
  margin-right: 14px;
  cursor: pointer;
}
.imageTable {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  width: 50px;
  height: 45px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-sizing: border-box;
}
.widthInherit {
  width: 36px;
  height: 36px;
}

.drop-down {
  width: 100px;
}
::v-deep .table thead th {
  align-items: center;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #555555;
}
::v-deep .table td {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
  text-align: right;
  color: #555555;
  padding: 18px;
}
::v-deep .pointer {
  cursor: pointer !important;
}
.three-dot {
  width: 15px;
  height: 15px;
}
.main-table tbody tr:hover {
  cursor: pointer;
  background-color: #eee;
}
.topDivTable {
  height: 310px;
  overflow: auto;
  // overflow-x: hidden ;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.topDivTable::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.topDivTable {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.theadFixed {
  position: sticky;
  top: 0;
  z-index: 10;
}
.productImg {
  border-radius: 4px !important;
  width: 45px;
  height: 37px;
}
.userImg {
  border-radius: 50% !important;
  width: 32px;
  height: 32px;
}
.userPic {
  font-size: 45px;
  color: #556ee6;
}
.w-40,
.w-img {
  width: 40px !important ;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
}
.w-110 {
  width: 110px !important ;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
}
.w-name {
  width: 350px !important ;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
}
.mainThead {
  background-color: #f8f9fa;
}
.colorDiv {
  width: 12px;
  height: 12px;
  border-radius: 1px;
  position: relative !important;
}
.fileStyle {
  font-size: 23px;
  font-weight: 100;
  padding: 1px;
}

.search-box {
  width: 284px;
  height: 71px;
  padding: 20px 10px;
  border: 2px solid #ffffff;
  box-shadow: 0px 0px 4px rgba(140, 140, 140, 0.3);
  border-radius: 4px;
  position: absolute;
  background: #fff;
  z-index: 3;
  input {
    width: 100%;
    border: 1px solid #eff2f7;
    border-radius: 3px;
    font-size: 13px;
    padding: 5px;
    outline: none;
  }
}

.arrow {
  cursor: pointer;
  display: inline-block;
  position: relative;
}

.checkbox {
  font-size: 18px;
  margin-top: -15px;
}

.fa-circle-xmark {
  display: flex;
  justify-content: flex-end;
  margin: 0.2rem 3rem;
}

.score {
  width: 60%;
  outline: none;
  border: 1px solid #cfcfcf;
  color: #555555;
  padding: 5px 10px;
  border-radius: 4px;
  top: 10px;
}

.mb-0 {
  width: 100%;
  overflow-x: overlay;
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}

.redIcon {
  color: #ed4747;
}

.eye {
  margin-right: 50px;
  position: relative;
  z-index: 100;
  font-size: 16px;
}

@media (max-width: 1024px) {
  .eye {
    margin-right: 0;
  }
}
</style>
